module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Sport2-ebb14624ad5daeeaa6bb4bb410c0fa4c.png";